import nakaharaImg from '~/assets/images/interview/nakahara_main.jpg';
import hsuImg from '~/assets/images/interview/hsu_main.jpg';
import suzuki1Img from '~/assets/images/interview/suzuki1_main.jpg';
import suzuki2Img from '~/assets/images/interview/suzuki2_main.jpg';

type Data = {
  nakahara: Person;
  hsu: Person;
  suzuki1: Person;
  suzuki2: Person;
};
export type Person = {
  ja: Info;
  en: Info;
};

type Info = {
  lead: string;
  name: string;
  title: string;
  img: string;
};

export const InterviewData: Data = {
  nakahara: {
    ja: {
      name: '中原さとみ',
      title: 'シネマティック・スーパーバイザー',
      lead: 'ハリウッド作品を手がけたシネマティックアーティストがグローバルな作品を成功に導くための秘訣',
      img: nakaharaImg,
    },
    en: {
      name: 'Satomi Nakahara',
      title: 'Cinematic Supervisor',
      lead: 'Cinematic Artist Who Has Worked on Hollywood Productions Share Her Secrets for Successful Global Productions',
      img: nakaharaImg,
    },
  },
  hsu: {
    ja: {
      name: 'レイ・シュー',
      title: 'アニメーション・スーパーバイザー',
      lead: 'ベテランアニメーターがBlizzardで得たものとは',
      img: hsuImg,
    },
    en: {
      name: 'Ray Hsu',
      title: 'Animation Supervisor',
      lead: 'What Did This Veteran Animator Gain at Blizzard?',
      img: hsuImg,
    },
  },
  suzuki1: {
    ja: {
      name: '鈴木卓矢',
      title: '取締役/モデリング・スーパーバイザー',
      lead: '『スーパーマリオワールド』に憧れた小学生が、世界屈指の背景アーティストとして評価されるまでの軌跡',
      img: suzuki1Img,
    },
    en: {
      name: 'Takuya Suzuki',
      title: 'Director/Environment Modeling Supervisor',
      lead: 'From Super Mario Fan to Global Background Art Master: A Creative Journey',
      img: suzuki1Img,
    },
  },
  suzuki2: {
    ja: {
      name: '鈴木卓矢',
      title: '取締役/モデリング・スーパーバイザー',
      lead: '「AAAタイトル」や「Netflixシリーズ」から指名される、鈴木卓矢が考える「頭一つ抜き出る」ための考え方とこれからの背景制作',
      img: suzuki2Img,
    },
    en: {
      name: 'Takuya Suzuki',
      title: 'Director/Environment Modeling Supervisor',
      lead: 'Standing Out in Background Production—From AAA Games to Netflix and Beyond',
      img: suzuki2Img,
    },
  },
};
